import React from 'react';

import { Container } from 'Components/Utilities';
import { Link } from 'react-router-dom';
import { asset } from 'Services/BaseHelpers';
import User from 'Services/User';

export default class Unauthenticated extends React.Component {
    /**
     * @method render
     * @returns {JSX.Element}
     */
    render () {
        const {children, pageTitle} = this.props;

        return (
            <div className="min-h-screen flex flex-col justify-between bg-app-blue-dark px-8 py-10 lg:bg-header-logo bg-contain bg-no-repeat bg-right font-light">
                <div className="w-full lg:w-max boots-sharp text-2xl text-white bg-header-logo lg:bg-none bg-contain bg-no-repeat bg-right">
                    <p className="font-bold">
                        Fragrance Event
                    </p>
                </div>

                <div>
                    {children}
                </div>

                <div className="text-white pt-8">
                    <a href="https://www.boots.com/floating-editorial/editorial-legal/privacypolicy" target="_blank">
                        Privacy Policy
                    </a>
                </div>
            </div>
        );
    }
}
